// extracted by mini-css-extract-plugin
export default {"divTxt":"Text_divTxt__R-GKp","txt":"Text_txt__IYZKk"};